// extracted by mini-css-extract-plugin
module.exports = {"headerBody":"header_headerBody__1PMeZ","title_text":"header_title_text__3s486","headerUl":"header_headerUl__Udy4C","headerLi":"header_headerLi__2KuKL"};